import { FC } from 'react';

import { Button } from '@argenta/react-ui';
import { Trans } from '@lingui/react';

import { useGetJobId } from '../../hooks/navigation/useGetJobId';
import { useI18nNavigate } from '../../hooks/navigation/useI18nNavigate';
import { VacancyApplicationLocationState } from '../../pages/VacancyApplication/VacancyApplication.types';
import { VacanciesRoute } from '../../routers/AppRouter/routes';

import { VacancyApplyButtonProps } from './VacancyApplyButton.types';

export const VacancyApplyButton: FC<VacancyApplyButtonProps> = ({ vacancyDetails }) => {
  const navigate = useI18nNavigate<VacancyApplicationLocationState>();
  const jobId = useGetJobId();

  if (!vacancyDetails) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  const handleApplicationClick = (): void => {
    navigate(VacanciesRoute.VACANCY_APPLICATION_FORM, { state: { ...vacancyDetails, jobId } });
  };
  return (
    <Button className="argnt-c-vacancy-details__apply-button" onClick={handleApplicationClick}>
      <Trans id="vacancies.details.applyOnline" values={{}} components={{}} />
    </Button>
  );
};
